import { Box, IconButton, styled, useTheme } from '@mui/material';
import { ArrowBackIosNew } from '@mui/icons-material';
import { ElementType, useState } from 'react';
import { Participants } from './Participants';
import Workspace from './Workspace';
import { CONVERSATION_DRAWER_WIDTH, CONVERSATION_MINI_DRAWER_WIDTH } from '@/constants/layout';
import { ConversationView, HelperSummary } from '@my-helpers/common';


const DrawerContainer = styled(Box)(({ theme }) => ({
    flexShrink: 1,
	borderLeft: `1px solid ${theme.palette.divider}`,
	backgroundColor: theme.palette.background.paper,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen
	})
}));

type ConversationDrawerProps = {
    isLoading?: string;
    currentConversation?: ConversationView;
    availableHelpers?: HelperSummary[];
    selectedParticipant?: string;
    setSelectedParticipant: (participantId?: string) => void;
};

const ConversationDrawer: ElementType<ConversationDrawerProps> = ({
    isLoading,
    currentConversation,
    availableHelpers,
    selectedParticipant, 
    setSelectedParticipant 
}) => {
    const theme = useTheme();
    const [drawerIsOpen, setDrawerIsOpen] = useState(false);

    return (
            <DrawerContainer
                width={
                    drawerIsOpen ? 
                    CONVERSATION_DRAWER_WIDTH : 
                    CONVERSATION_MINI_DRAWER_WIDTH
                }
            >
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row'
                }}>
                    <Box sx={{
                        display: 'flex',
                        flex: 0,
                        alignItems: 'center',
                        flexDirection: 'column',
                        backgroundColor: 'grey.100',
                        pt: 1,
                        px: 0.8,
                    }}>
                        <IconButton
                            onClick={() => setDrawerIsOpen(!drawerIsOpen)}
                            sx={{
                                transform: drawerIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: theme.transitions.create('transform', {
                                    duration: theme.transitions.duration.short
                                })
                            }}
                        >
                            <ArrowBackIosNew sx={{ fontSize: 'small' }} />
                        </IconButton>
                    </Box>
                    {drawerIsOpen && (
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            backgroundColor: 'grey.100',
                        }}>
                            <Participants 
                                isLoading={isLoading}
                                participants={availableHelpers}
                                selectedParticipant={selectedParticipant}
                                setSelectedParticipant={setSelectedParticipant}
                            />
                            <Workspace />
                        </Box>
                    )}
                </Box>
            </DrawerContainer> 
    );
};

export default ConversationDrawer;
